import React from 'react'
import PropTypes from 'prop-types'
import styles from '../ProfileOverview/styles'

const PreferredLocations = ({ preferredCities, className }) => {
  const onlyCities = preferredCities.filter(city => city !== 'Remote')
  const prefersRemote = preferredCities.includes('Remote')

  return (
    <div className={className}>
      <span className={styles.boldText}>Wants to work{onlyCities.length > 0 && ' in'} </span>
      {onlyCities.length > 0 && onlyCities[0]}
      {prefersRemote && (onlyCities.length > 0 ? ' or remotely' : 'remotely')}
    </div>
  )
}

PreferredLocations.propTypes = {
  className: PropTypes.string,
  preferredCities: PropTypes.arrayOf(PropTypes.string),
}

export default PreferredLocations
